import { render } from "./TableItemOF.vue?vue&type=template&id=1b64864b"
import script from "./TableItemOF.vue?vue&type=script&lang=ts"
export * from "./TableItemOF.vue?vue&type=script&lang=ts"
script.render = render

export default script